<template>
  <div>
    <google-map
      :style="{ width: 'auto', height: height + 'px' }"
    />
    <div v-if="showRecommend" class="absolute inline-block -mt-6 w-full h-10 text-center">
      <a @click="openPlaceList" class="inline-flex justify-center items-center px-4 h-6 bg-white rounded-t text-link shadow-sm">{{ $t('search_place') }}</a>
    </div>
    <template v-if="showPlaceList || showPlace">
      <div class="transform absolute bg-white bottom-0 w-full ease-in-out transition-all duration-300 z-10"
        :class="[
          (showPlace || showPlaceList) ? 'translate-y-0' : 'translate-y-all',
          drawerHeight
        ]">
        <place-detail v-show="showPlace" />
        <place-list
          v-show="showPlaceList"
          @close="onClosePlaceList" />
      </div>
    </template>
    <location-button @getLocation="onGetLocation" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import GoogleMap from './GoogleMap'
import PlaceDetail from './PlaceDetail'
import PlaceList from './PlaceList'
import LocationButton from '../../molecules/LocationButton'
import Constants from '../../../constants'

export default {
  components: {
    GoogleMap,
    PlaceDetail,
    PlaceList,
    LocationButton
  },
  props: {
    showSearchPanel: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      showPlaceList: false,
      showRecommend: (Constants.API_ID === "SENDAI2" || Constants.API_ID === "OKUKYOTO") ? true : false,
      windowHeight: window.innerHeight
    }
  },
  mounted () {
    window.addEventListener('resize', ()=>{
      this.windowHeight = window.innerHeight
    })
  },
  methods: {
    openPlaceList: function () {
      this.$store.dispatch('map/recommendSearchCourse')
      this.showPlaceList = true
      this.full = false
    },
    onClosePlaceList: function () {
      this.showPlaceList = false
    },
    onGetLocation: function (location) {
      this.$store.dispatch('map/updateCenter', location)
    }
  },
  computed: {
    ...mapGetters({
      selectedPlace: 'map/getSelectedPlace',
      showPlaceFull: 'map/getShowPlaceFull',
      center: 'map/getCenter'
    }),
    height: function () {
      // header: 48, foot: 45
      const h = (!_.isEmpty(this.selectedPlace) && this.showPlaceFull) ? 300 : 48 + 45
      return this.windowHeight - h
    },
    showPlace: function () {
      return !_.isEmpty(this.selectedPlace)
    },
    drawerHeight: function () {
      if (this.showPlaceList) {
        return 'h-52'
      } else if(this.selectedPlace.isGooglePlace) {
        return 'h-72'
      } else {
        return this.showPlaceFull ? 'h-96' : 'h-32'
      }
    }
  },
  watch: {
    selectedPlace: function (val) {
      if (!_.isEmpty(val)) this.showPlaceList = false
    },
    center: function () {
      this.showPlaceList = false
    }
  }
}
</script>
